
import React from 'react'

// hard services1
import multi_skill_technician from '../images/services/hard_services1/multiskill-technician.png'
import plumber from '../images/services/hard_services1/plumber.png'
import technicians from '../images/services/hard_services1/technician.png'
import bms_operator from '../images/services/hard_services1/BMS-operator.png'
import gym_instruction from '../images/services/hard_services1/gym-instruction.png'

// soft services1
import house_keeping from '../images/services/soft_services1/housekeeping.png'
import front_office_managment from '../images/services/soft_services1/reception.png'
import office_managment from '../images/services/soft_services1/office-management.png'
import office_boy from '../images/services/soft_services1/office-boy.png'
import pantry_service from '../images/services/soft_services1/pantry.png'
import office_admin from '../images/services/soft_services1/admin.png'
import gardening from '../images/services/soft_services1/gardening.png'
import swimming_pool from '../images/services/soft_services1/swimming_pool.png'

//security services
import security_guard from '../images/services/security_services/policeman.png'
import security_supervisor from '../images/services/security_services/police.png'
import escort_guard from '../images/services/security_services/securityguard.png'
import security_officer from '../images/services/security_services/policeman1.png'
import parking_management from '../images/services/security_services/parking-management.png'


function Services({params}) {

  const hard_services = [
    {   
        id:1,
        name:'Multi Skill Technician',
        img:multi_skill_technician
    },
    {   
        id:2,
        name:'Plumber',
        img:plumber
    },
    {   
        id:3,
        name:'Technicians',
        img:technicians
    },
    {   
        id:4,
        name:'BMS Operators',
        img:bms_operator
    },
    {   
        id:5,
        name:'Gym Instruction',
        img:gym_instruction
    },
    
  ]

  const soft_services = [
    {   
        id:1,
        name:'Housekeeping services',
        img:house_keeping
    },
    {   
        id:2,
        name:'Front Office Management',
        img:front_office_managment
    },
    {   
        id:3,
        name:'Office Management',
        img:office_managment
    },
    {   
        id:4,
        name:'Runner Boy',
        img:security_guard
    },
    {   
        id:5,
        name:'Office Boy',
        img:office_boy
    },
    {   
        id:6,
        name:'Pantry Services',
        img:pantry_service
    },
    {   
        id:7,
        name:'Office Admin',
        img:office_admin
    },
    {   
        id:8,
        name:'Gardner',
        img:gardening
    },
    {   
        id:9,
        name:'Swimming Pool Maintenance',
        img:swimming_pool
    },
   
  ]
  
  const fumigation_services = [
    {   
        id:1,
        name:'Security Guard',
        img:security_guard
    },
    {   
        id:2,
        name:'Security Supervisor',
        img:security_supervisor
    },
    {   
        id:3,
        name:'Escort Guard',
        img:escort_guard
    },
    {   
        id:4,
        name:'Security Officer',
        img:security_officer
    },
    {   
        id:5,
        name:'Parking Management',
        img:parking_management
    },
  ]

//   const { servicesId } = router.query

  return (
    <div className='w-full h-full overflow-hidden'>
          <div className='min-h-[180px] bg-black  relative md:min-h-[240px] 2xl:min-h-[500px] bg-cover md:bg-contain bg-no-repeat w-full bg-right-top bg-services_bg'>
          <div data-aos="fade-left" className='absolute top-[5%] md:top-[15%]  w-[75%] md:w-[35%]' >
            <div className='border-l w-full border-l-4  border-l-[#4190ac] ml-[6%] pl-[1.5%] absolute top-[15%]'>
                <h6 className='text-[19px] 2xl:text-[22px] font_thicker md:text-[21px] text-[#fff] font-[800]  '>Our Services</h6>
                <h6 className='text-[18px] 2xl:text-[21px] md:text-[21px] text-[#fff] font-[800]  '>{params?.servicesId === 'security_services' && 'Security Services'} {params?.servicesId === 'hard_services' && 'Hard Services'} {params?.servicesId === 'soft_services' && 'Soft Services'}</h6>
                <h6 className='text-[13px] 2xl:text-[16px]  md:text-[14px] text-[#fff]'>our services includes both Hard and Soft services with the main security services! </h6>
            </div>
          </div>
        </div>
        <div className='w-[80%] mx-auto py-20'>
           {/* Detail Page {params?.servicesId} */}


           {/* security services  */}

           {/* {params?.servicesId  === "security_services" && */}
           <>

            <h6 className='font_thicker text-[20px] 2xl:text-[23px] mb-4'>Security & Escorting Services</h6>
            <h6 className='text-[14.5px] 2xl:text-[17.5px] font_normal'>“Elevate Facility Security with Our Expert Services Our facility management includes top-tier security solutions, ensuring a safe environment. From access control to vigilant monitoring, we prioritize occupant protection. Experience peace of mind and a secure facility with our comprehensive security services.”</h6>


            <div className='grid grid-cols-2 md:grid-cols-6 mt-10 gap-2'>
               {fumigation_services?.map((s,i)=>(
                <div key={i} data-aos="fade-up" className='w-full flex flex-col items-center justify-center'>
                   <img alt={s?.img} className={`opacity-80 object-contain  h-[65px] flex items-center `} src={s?.img} /> 
                   <h6 className='mt-2 text-[13px] 2xl:text-[16px] w-[90%] text-center mb-4 font_thicker'>{s?.name}</h6>
                </div>   
               ))}
            </div> 


            <h6 className='font_thicker text-[15px] 2xl:text-[18px] mt-10'>We provide :</h6>

            <ul className='list-disc ml-6 mt-5'>
                <li className='text-[14px] 2xl:text-[17px] mt-1'>Proficient and vetted manpower</li>
                <li className='text-[14px] 2xl:text-[17px] mt-1'>Bodyguards / Gunman (with License)</li>
                <li className='text-[14px] 2xl:text-[17px] mt-1'>Enhanced safety for woman with escort guards</li>
                <li className='text-[14px] 2xl:text-[17px] mt-1'>Safety / Security audit</li>
                <li className='text-[14px] 2xl:text-[17px] mt-1'>Round the clock close monitoring</li>
                <li className='text-[14px] 2xl:text-[17px] mt-1'>Equipped to handle fire and health emergencies</li>
                <li className='text-[14px] 2xl:text-[17px] mt-1'>Good communication skills and ability in managing front office</li>
                <li className='text-[14px] 2xl:text-[17px] mt-1'>Access Control / CCTV Monitoring</li>
                <li className='text-[14px] 2xl:text-[17px] mt-1'>Security Screening / Car Parking</li>
                <li className='text-[14px] 2xl:text-[17px] mt-1'>Guards / Supervisor / Mobile Patrol</li>
                <li className='text-[14px] 2xl:text-[17px] mt-1'>24/7 Emergency Services</li>
                <li className='text-[14px] 2xl:text-[17px] mt-1'>Managing Building Management System Rooms in Tech Equipped Buildings</li>
            </ul>
           </>
           {/* } */}

           {/* {params?.servicesId  === "hard_services" && */}
           <>

            <h6 className='font_thicker text-[20px] 2xl:text-[23px] mt-10 my-4'>Hard Services</h6>
            <h6 className='text-[14.5px] 2xl:text-[17.5px] font_normal'>“Empowering Your Space with Robust Hard Services Discover our facility management’s hard services, delivering tangible solutions for your facility’s infrastructure. From maintenance to technical support, we ensure smooth operations. Experience reliability, efficiency, and longevity in your facility through our comprehensive hard services.”</h6>
            <h6 className='text-gray-500 font_thicker text-[18px] 2xl:text-[21px] opacity-70 mt-5'>Our Services include:</h6>

            <div className='grid grid-cols-2 md:grid-cols-6 mt-10 gap-2'>
               {hard_services?.map((s,i)=>(
                <div key={i} data-aos="fade-up" className='w-full flex flex-col items-center justify-center'>
                   <img alt={s?.img} className={`opacity-80 object-contain  h-[65px] flex items-center `} src={s?.img} /> 
                   <h6 className='mt-2 text-[13px] 2xl:text-[16px] w-[90%] text-center mb-4 font_thicker'>{s?.name}</h6>
                </div>   
               ))}
            </div> 
           </>
           {/* } */}

           {/* {params?.servicesId  === "soft_services" && */}
           <>
            <h6 className='font_thicker text-[20px] 2xl:text-[23px] mt-10 my-4'>Soft Services</h6>
            <h6 className='text-[14.5px] 2xl:text-[17.5px] font_normal'>“Discover Our Comprehensive Soft Services for Enhanced Facility Management Experience a seamless blend of cleaning, security, reception, and customer support in our facility management solutions. We prioritize occupant comfort and satisfaction, ensuring a harmonious environment for productivity and well-being.”</h6>
            <h6 className='text-gray-500 font_thicker text-[18px] 2xl:text-[21px] opacity-70 mt-5'>Our Services include:</h6>

            <div className='grid grid-cols-2 md:grid-cols-6 mt-10 gap-2'>
               {soft_services?.map((s,i)=>(
                <div key={i} data-aos="fade-up" className='w-full flex flex-col items-center justify-center'>
                   <img alt={s?.img} className={`opacity-80 object-contain  h-[65px] flex items-center `} src={s?.img} /> 
                   <h6 className='mt-2 text-[13px] 2xl:text-[16px] w-[90%] text-center mb-4 font_thicker'>{s?.name}</h6>
                </div>   
               ))}
            </div> 
           </>
           {/* } */}

        </div>
    </div>
  )
}

export default Services